import React from 'react'
import Restricted from '../Components/Errors/Restricted'

const RestrictedPage = () => {
  return <Restricted />
}

export default RestrictedPage
